// extracted by mini-css-extract-plugin
module.exports = {"LangSwitcher":"styles_LangSwitcher__2MCGZ","wrapper":"styles_wrapper__34CJt","label":"styles_label__3r2bo"};